import React, { createContext, useState } from 'react';

export const MyContext = createContext();

export const MyProvider = ({ children }) => {
  const [contextValue, setContextValue] = useState({
    status: false,
    errorMessage: '',
    expiry: '',
    userMessage: '',
  });

  return (
    <MyContext.Provider value={{ contextValue, setContextValue }}>
      {children}
    </MyContext.Provider>
  );
};